import { fromJS, Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import requestStatus from '../../constants/requestStatus'
import { ROUTES_DATA } from '../../constants/state';


const INIT_STATE = fromJS({
    status: requestStatus.INITIALIZED,
    error: null,
    frontpage: {},
    program_overview: {},
    movies: {
        items: {}
    }
});

const onGet = (state, action)       => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', '')

const onError = (state, action)     => state.set('status', requestStatus.REQUEST_ERROR)
                                            .set('error', action.payload.errorMessage)

const onSuccess = (state, action)   => fromJS({
    status: requestStatus.REQUEST_SUCCESS,
    error: '', 
    frontpage: action.payload.frontpage,
    program_overview: action.payload.program_overview,
    movies: action.payload.movies
})


const routesDataReducer = (state = INIT_STATE, action) => {
    switch(action.type){
        case actionTypes.WP_ROUTES_DATA_GET_REQUEST:
            return onGet(state, action);
        case actionTypes.WP_ROUTES_DATA_GET_SUCCESS:
            return onSuccess(state, action)
        case actionTypes.WP_ROUTES_DATA_GET_ERROR:
            return onError(state, action)
        default:
            return state
    }
}

export default routesDataReducer;